import React, { useState, useEffect, useRef } from "react"
import NexmartPanel from "./NexmartPanel"
import DealerFinder from "./DealerFinder"
import NexmartDealerFinder from "./NexmartDealerFinder"

import { useTranslation } from "react-i18next"
import FluidHeadline from "../atoms/FluidHeadline"

const BuyProductPanel = ({
  sku,
  suppressNexmart = false,
  startAtTab = "dealer",
}) => {
  const [activeTab, setActiveTab] = useState(startAtTab)
  const [hideOnlineTab, setHideOnlineTab] = useState(suppressNexmart)
  const scrollUpRef = useRef(null)

  const { t } = useTranslation()

  const handleNexmartCallback = (hasResults) => {
    if (hasResults === false) {
      setActiveTab("dealer")
      setHideOnlineTab(true)
    }
  }

  const handleTabClick = (tab) => {
    if (tab === "online") {
      window.adf && adf.ClickTrack({}, 2861695, "Online Kaufen", {})
    } else {
      window.adf &&
        adf.ClickTrack({}, 2861695, "Fachhändler in der Nähe finden", {})
    }
    setActiveTab(tab)
  }

  const handleScrollUp = () => {
    if (scrollUpRef.current) {
      scrollUpRef.current.scrollTop = 0
    }
  }

  return (
    <section className="h-full">
      <div className="p-8">
        <FluidHeadline headline={t("generic.products.find_a_dealer")} />
      </div>
      <div
        className="flex flex-col h-full max-h-[calc(100dvh-8.25rem)] md:max-h-[calc(100dvh-9.75rem)] overflow-y-auto scroll-smooth"
        ref={scrollUpRef}
      >
        <div className="">
          <div className="mx-auto max-w-screen-2xl">
            <div className="flex flex-row overflow-y-auto px-grid">
              <button
                key="buyTabDealer"
                className={` btn whitespace-nowrap ml-px ${
                  activeTab === "dealer"
                    ? "bg-ro-gray-50 pointer-events-none btn border-y-2 border-t-ro-red border-b-ro-gray-50"
                    : "text-ro-gray-600 bg-ro-gray-100 btn hover:bg-ro-gray-150 hover:text-ro-gray-900 border-y-2 border-y-ro-gray-100 hover:border-y-ro-gray-150"
                }`}
                onClick={() => handleTabClick("dealer")}
              >
                {t("generic.products.buy_on_site")}
              </button>
              {hideOnlineTab !== true && (
                <button
                  key="buyTabNexmart"
                  className={` btn whitespace-nowrap ml-px ${
                    activeTab === "online"
                      ? "bg-ro-gray-50 pointer-events-none btn border-y-2 border-t-ro-red border-b-ro-gray-50"
                      : "text-ro-gray-600 bg-ro-gray-100 btn hover:bg-ro-gray-150 hover:text-ro-gray-900 border-y-2 border-y-ro-gray-100 hover:border-y-ro-gray-150"
                  }`}
                  onClick={() => handleTabClick("online")}
                  id="SwitchToOnlineRetailer"
                >
                  {t("generic.products.order_online")}
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="w-full h-full mx-auto bg-ro-gray-50">
          <div
            key="tabPanelOnline"
            className={` ${activeTab === "online" ? "block" : "hidden"}`}
          >
            <div className="p-8 bg-ro-gray-50">
              <div className="lg:w-1/2">
                {t("generic.products.intro_order_online")}
              </div>
            </div>
            {sku && !suppressNexmart && (
              <>
                <NexmartPanel
                  sku={sku}
                  retailersFoundCallback={handleNexmartCallback}
                />
              </>
            )}
          </div>
          <div
            key="tabPanelDealer"
            className={` ${activeTab === "dealer" ? "block" : "hidden"}`}
          >
            <div className="p-8 bg-ro-gray-50">
              <div className="lg:w-1/2">
                {t("generic.products.intro_dealer_search")}
              </div>
            </div>
            <NexmartDealerFinder
              modalMode={true}
              modalModeScrollUpFunction={() => handleScrollUp()}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default BuyProductPanel
